<template>
  <div class="p10 flex-warp ">
    <div v-if="urlArr.length<limit" @click="selectFile" class="flex-c bra6 f20" style="width:146px;height:146px;border: 1px dashed #666;background-color: var(--el-fill-color-lighter);">
      <i v-if="!loading" class="el-icon-plus f40"></i>
      <i v-if="loading" class="el-icon-loading f40"></i>
    </div>
    <div  
      v-for="(item,index) in urlArr" :key="item"
      v-if="item"
      class="bra6 mr10 flex"
      style="width:200px;border: 1px solid var(--el-border-color-darker);"
    >
      <el-popconfirm
        title="确定删除吗？"
        @confirm="urlArr.splice(index,1),urlChange()"
      >
        <div class="f20 ml5" slot="reference">
          <img :src="item" style="width:146px;height:146px;object-fit: contain;" />
          <i class="el-icon-delete"></i>
        </div>
      </el-popconfirm>
    </div>
  </div>
</template>

<script>
import axios  from 'axios';
let uploadIndex=0
  export default {
    props: {
    action: {
      type: String,
      defalut: "",
    },
    prefix:{// 路由前缀
      type:String,
      default:"icp",
    },
    url: {
      type: String,
      defalut: "",
    },
    limit: {
      type: Number,
      defalut: 1,
    },
  },
  data() {
    return {
      urlArr: [],
      loading:false,
    }
  },
  watch: {
    url() {
      console.log(39, this.url);
      this.urlArr = this.url.split(",")
    },
  },
  methods: {
    urlChange() {
      console.log(187, this.urlArr);
      
      console.log(45, this.urlArr.join(","));
      console.log(45.1, this.url);
      console.log(45.2, this.urlArr.filter(item=>!!item));

      this.$emit("update:url", this.urlArr.filter(item=>!!item).join(","))

      console.log(50, this.url);
      console.log(50.1, this.urlArr);
    },
    selectFile(index) {
      let input = document.createElement('input');
      input.setAttribute('type', 'file');
      // input.setAttribute('multiple', 'multiple');
      input.accept = "image/*"
      input.addEventListener('change', (e, e2, e3) => {
        // console.log(365.0, e,e2,e3);
        // console.log(365.1, e.path,e.target);
        // console.log(366.1, e.target.files);
        // console.log(367.1, e.target.files[0]);
        // console.log(368.1, e.target.files);
        // console.log(365.1, e.path);
        // console.log(365.2, e.path[0]);
        // console.log(365.3, e.target.files);
        // console.log(365.4, e.target.files[0]);
        console.log(413, e.target);
        // this.clipImage.show = true
        // this.option.img = e.target.files[0]

        // this.option.img = window.URL.createObjectURL(e.target.files[0]) 
        let imgFile = e.target.files[0]
        // console.log(68, oss);

        // 在这里进行一系列的校验
        // const formData = new FormData();

        // formData.append("file", imgFile);
        this.loading = true
        axios({
    url: "https://www.shanganzhilu.com/api/h5-api/infra/file/upload",
    method: "post",// 默认是 get
    params: {},//query参数
    data: {
      path:`${this.prefix}/${Date.now()}.${uploadIndex++}.${imgFile.name}`,
          // path:`goods/uuid.png`,
          file:imgFile,
    },//body参数
    headers: {
        "Content-type":'multipart/form-data'
    }
})
        // axios.post("http://admin.shanganzhilu.com/api/admin-api/infra/file",{
        //   path:`${this.prefix}/${Date.now()}.${uploadIndex++}.${imgFile.name}`,
        //   // path:`goods/uuid.png`,
        //   file:imgFile,
        // }, {
        //   'Content-type': 'multipart/form-data'
        // })
        .then(axiosRes => {
          console.log(396, axiosRes);

          let res = axiosRes.data
          console.log(226,res);
          
          this.urlArr.push(res.data)

          // this.clipImage.show = false
          this.urlChange()
        }).finally(err => {
          this.loading = false
        })
      })
      input.click()
    },
  },
  }
</script>

<style scoped>

</style>